// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/tui-image-editor/dist/tui-image-editor.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/tui-color-picker/dist/tui-color-picker.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tui-image-editor-header-logo {
  display: none;
}

.container {
  position: relative;
  width: 100%;
  height: 100%;
}

.tie-btn-delete {
  display: none !important;
}

.tie-btn-deleteAll {
  display: none !important;
}

.tui-image-editor-header-buttons {
  display: none;
}

.save-button {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 99999;
  display: inline-block;
  width: 80px;
  height: 40px;
  padding: 0;
  line-height: 40px;
  outline: none;
  border-radius: 20px;
  border: 1px solid #ddd;
  font-family: "Noto Sans", sans-serif;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  vertical-align: middle;
  letter-spacing: 0.3px;
  text-align: center;
  background-color: #fdba3b;
  border: 1px solid #fdba3b;
  color: #fff;
  font-size: 12px;
}

.tui-image-editor {
  width: 300px;
  height: 90px;
  overflow: hidden;
}

.tui-image-editor-container {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  min-height: 300px;
  height: 100%;
  position: relative;
  background-color: #282828;
  overflow: hidden;
  letter-spacing: 0.3px;
}

.tui-image-editor-container .tui-image-editor-submenu {
  height: 60px;
}

.tui-image-editor-container.bottom .tui-image-editor-submenu > div {
  padding: 0;
}

.tui-image-editor-container .tui-image-editor-controls {
  height: 50px;
}

.tui-image-editor-container .tui-image-editor-submenu .tui-image-editor-submenu-item .tui-image-editor-newline {
  display: inline-block;
}

textarea[data-fabric-hiddentextarea] {
  top: 0 !important;
  left: 0 !important;
}`, "",{"version":3,"sources":["webpack://./res/stylesheets/editorPicture.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AAAJ;;AAGA;EACI,wBAAA;AAAJ;;AAGA;EACI,wBAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAEA;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,WAAA;EAEA,eAAA;AAAJ;;AAGA;EACI,YAAA;EACA,YAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,UAAA;AAAJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EAII,qBAAA;AAFJ;;AAMA;EACI,iBAAA;EACA,kBAAA;AAHJ","sourcesContent":["@import '~tui-image-editor/dist/tui-image-editor.css';\n@import '~tui-color-picker/dist/tui-color-picker.css';\n\n.tui-image-editor-header-logo {\n    display: none;\n}\n\n.container {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.tie-btn-delete {\n    display: none !important;\n}\n\n.tie-btn-deleteAll {\n    display: none !important;\n}\n\n.tui-image-editor-header-buttons {\n    display: none;\n}\n.save-button {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    z-index: 99999;\n    display: inline-block;\n    width: 80px;\n    height: 40px;\n    padding: 0;\n    line-height: 40px;\n    outline: none;\n    border-radius: 20px;\n    border: 1px solid #ddd;\n    font-family: 'Noto Sans', sans-serif;\n    font-size: 12px;\n    font-weight: bold;\n    cursor: pointer;\n    vertical-align: middle;\n    letter-spacing: 0.3px;\n    text-align: center;\n    background-color: #fdba3b;\n    border: 1px solid #fdba3b;\n    color: #fff;\n    // font-family: 'Noto Sans', sans-serif;\n    font-size: 12px;\n}\n\n.tui-image-editor {\n    width: 300px;\n    height: 90px;\n    overflow: hidden;\n}\n\n.tui-image-editor-container {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    min-height: 300px;\n    height: 100%;\n    position: relative;\n    background-color: #282828;\n    overflow: hidden;\n    letter-spacing: 0.3px;\n}\n\n.tui-image-editor-container .tui-image-editor-submenu {\n    height: 60px;\n}\n\n.tui-image-editor-container.bottom .tui-image-editor-submenu > div {\n    padding: 0;\n}\n.tui-image-editor-container .tui-image-editor-controls {\n    height: 50px;\n}\n\n.tui-image-editor-container\n    .tui-image-editor-submenu\n    .tui-image-editor-submenu-item\n    .tui-image-editor-newline {\n    display: inline-block;\n}\n\n\ntextarea[data-fabric-hiddentextarea] {\n    top: 0 !important;\n    left: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
